import { createStore, combineReducers, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'es6/redux/middleware/logger';
import { itemsReducer, itemsMemoriesReducer } from 'es6/redux/modules/items';
import itemsSaga from 'es6/redux/sagas/items';

const reducers = combineReducers({
  items: itemsReducer,
  itemsMemories: itemsMemoriesReducer,
});

const saga = createSagaMiddleware(itemsSaga);

export default () => createStore(reducers, applyMiddleware(logger, saga));
